export default "__VITE_ASSET__BrVWszkG__"